// Policy / About-supporting pages content. Kept as structured data so the same
// PolicyPage component renders any of them and Footer keeps a single source of truth.

const D = {
  advertise: {
    slug: "advertise",
    href: "/policy/advertise",
    footerLabel: "Advertise With Us",
    eyebrow: "Advertise With Us",
    title: "Partner With Denva Post",
    intro:
      "Denva Post पर विज्ञापन देकर आप अपने ब्रांड, व्यवसाय, संस्था या अभियान को विश्वसनीय और तेजी से बढ़ते डिजिटल न्यूज़ प्लेटफ़ॉर्म के माध्यम से अपने लक्षित पाठकों तक पहुँचा सकते हैं।",
    blocks: [
      {
        type: "para",
        text: "हम निम्नलिखित विज्ञापन विकल्प उपलब्ध कराते हैं—",
      },
      {
        type: "list",
        items: [
          "Website Display Advertisements",
          "Homepage Banner Ads",
          "Sponsored Articles (स्पष्ट डिस्क्लोजर के साथ)",
          "Video Promotions",
          "Social Media Promotions",
        ],
      },
      {
        type: "para",
        text: "हम संपादकीय सामग्री और विज्ञापन के बीच स्पष्ट अंतर बनाए रखते हैं। किसी भी विज्ञापनदाता का हमारी संपादकीय नीतियों या समाचार चयन पर कोई प्रभाव नहीं होता।",
      },
      {
        type: "para",
        text: "यदि आप हमारे साथ विज्ञापन, ब्रांड सहयोग या अन्य व्यावसायिक साझेदारी करना चाहते हैं, तो हमारी सेल्स टीम से संपर्क करें।",
      },
    ],
    contact: { label: "Sales Team", email: "Sales@denvapost.com" },
  },

  editorial: {
    slug: "editorial",
    href: "/policy/editorial",
    footerLabel: "Editorial Policy",
    eyebrow: "Editorial Policy",
    title: "संपादकीय नीति",
    intro: "Denva Post स्वतंत्र, निष्पक्ष और तथ्य-आधारित पत्रकारिता के सिद्धांतों का पालन करता है।",
    blocks: [
      { type: "para", text: "हमारी संपादकीय प्राथमिकताएँ हैं—" },
      {
        type: "list",
        items: [
          "तथ्यपरक और संतुलित रिपोर्टिंग",
          "जनहित सर्वोपरि",
          "स्वतंत्र एवं निष्पक्ष पत्रकारिता",
          "सभी पक्षों को उचित अवसर",
          "विश्वसनीय स्रोतों का उपयोग",
          "पारदर्शिता और जवाबदेही",
        ],
      },
      {
        type: "para",
        text: "किसी भी समाचार को प्रकाशित करने से पहले उपलब्ध तथ्यों, आधिकारिक दस्तावेजों तथा संबंधित पक्षों का सत्यापन किया जाता है। यदि किसी कारणवश कोई पक्ष उपलब्ध नहीं हो पाता, तो उसे समाचार में स्पष्ट रूप से उल्लेखित किया जाता है।",
      },
    ],
  },

  "fact-check": {
    slug: "fact-check",
    href: "/policy/fact-check",
    footerLabel: "Fact-Checking Policy",
    eyebrow: "Fact-Checking Policy",
    title: "तथ्य-सत्यापन नीति",
    intro:
      "Denva Post पर प्रकाशित प्रत्येक समाचार यथासंभव सत्यापित तथ्यों के आधार पर तैयार किया जाता है।",
    blocks: [
      { type: "para", text: "तथ्यों के सत्यापन के लिए हम—" },
      {
        type: "list",
        items: [
          "आधिकारिक दस्तावेज़",
          "सरकारी रिकॉर्ड",
          "संबंधित अधिकारियों",
          "प्रत्यक्षदर्शियों",
          "विश्वसनीय स्रोतों",
          "ऑन-ग्राउंड रिपोर्टिंग",
        ],
      },
      { type: "para", text: "का उपयोग करते हैं।" },
      {
        type: "para",
        text: "यदि किसी प्रकाशित सामग्री में तथ्यात्मक त्रुटि की जानकारी मिलती है, तो उसका पुनः सत्यापन कर आवश्यक संशोधन किया जाता है।",
      },
    ],
  },

  corrections: {
    slug: "corrections",
    href: "/policy/corrections",
    footerLabel: "Corrections Policy",
    eyebrow: "Corrections Policy",
    title: "संशोधन नीति",
    intro: "पत्रकारिता में सटीकता हमारी प्राथमिकता है।",
    blocks: [
      {
        type: "para",
        text: "यदि किसी समाचार, फोटो, वीडियो या अन्य सामग्री में तथ्यात्मक त्रुटि पाई जाती है अथवा पाठकों द्वारा प्रमाण सहित किसी गलती की ओर ध्यान दिलाया जाता है, तो हमारी संपादकीय टीम उसका परीक्षण करती है।",
      },
      {
        type: "para",
        text: "त्रुटि प्रमाणित होने पर संबंधित सामग्री में आवश्यक संशोधन या सुधार यथाशीघ्र प्रकाशित किया जाता है।",
      },
      { type: "para", text: "सुधार संबंधी सूचना भेजने के लिए संपर्क करें—" },
    ],
    contact: { label: "Editor-in-Chief", email: "EditorInChief@denvapost.com" },
  },

  privacy: {
    slug: "privacy",
    href: "/policy/privacy",
    footerLabel: "Privacy Policy",
    eyebrow: "Privacy Policy",
    title: "गोपनीयता नीति",
    intro: "Denva Post अपने पाठकों की गोपनीयता का सम्मान करता है।",
    blocks: [
      {
        type: "para",
        text: "हम केवल वही जानकारी एकत्र करते हैं जो उपयोगकर्ता स्वेच्छा से साझा करते हैं, जैसे—",
      },
      { type: "list", items: ["नाम", "ईमेल पता", "संपर्क फ़ॉर्म में दी गई जानकारी"] },
      { type: "para", text: "इस जानकारी का उपयोग केवल—" },
      {
        type: "list",
        items: [
          "आपके संदेश का उत्तर देने",
          "वेबसाइट सेवाओं को बेहतर बनाने",
          "आवश्यक संचार भेजने",
          "सुरक्षा एवं दुरुपयोग रोकने",
        ],
      },
      { type: "para", text: "के लिए किया जाता है।" },
      {
        type: "para",
        text: "हम किसी भी उपयोगकर्ता की व्यक्तिगत जानकारी को बेचते, किराए पर देते या अनधिकृत रूप से साझा नहीं करते।",
      },
      {
        type: "para",
        text: "वेबसाइट पर Cookies तथा Analytics Tools का उपयोग उपयोगकर्ता अनुभव बेहतर बनाने के उद्देश्य से किया जा सकता है।",
      },
    ],
  },

  terms: {
    slug: "terms",
    href: "/policy/terms",
    footerLabel: "Terms & Conditions",
    eyebrow: "Terms & Conditions",
    title: "उपयोग की शर्तें",
    intro: "Denva Post का उपयोग करने का अर्थ है कि आप इन शर्तों से सहमत हैं।",
    blocks: [
      {
        type: "list",
        items: [
          "वेबसाइट पर प्रकाशित सामग्री कॉपीराइट द्वारा संरक्षित है।",
          "बिना पूर्व लिखित अनुमति सामग्री का पुनर्प्रकाशन, व्यावसायिक उपयोग या वितरण प्रतिबंधित है।",
          "उपयोगकर्ता वेबसाइट का उपयोग केवल वैध उद्देश्यों के लिए करेंगे।",
          "पाठकों द्वारा भेजी गई टिप्पणियों और सामग्री की जिम्मेदारी संबंधित उपयोगकर्ता की होगी।",
          "Denva Post किसी भी समय अपनी सेवाओं, सामग्री अथवा नीतियों में परिवर्तन करने का अधिकार सुरक्षित रखता है।",
        ],
      },
      {
        type: "para",
        text: "इस वेबसाइट से संबंधित सभी विवादों का क्षेत्राधिकार केवल नर्मदापुरम (मध्य प्रदेश) के सक्षम न्यायालयों को होगा।",
      },
    ],
  },

  disclaimer: {
    slug: "disclaimer",
    href: "/policy/disclaimer",
    footerLabel: "Disclaimer",
    eyebrow: "Disclaimer",
    title: "अस्वीकरण",
    intro:
      "Denva Post पर प्रकाशित समाचार, लेख और विश्लेषण उपलब्ध तथ्यों, आधिकारिक दस्तावेजों तथा विश्वसनीय स्रोतों के आधार पर तैयार किए जाते हैं।",
    blocks: [
      {
        type: "para",
        text: "यद्यपि सामग्री की सटीकता सुनिश्चित करने का हर संभव प्रयास किया जाता है, फिर भी किसी अनजानी तथ्यात्मक त्रुटि की संभावना से पूर्णतः इंकार नहीं किया जा सकता। ऐसी स्थिति में उचित प्रमाण प्राप्त होने पर आवश्यक संशोधन किया जाएगा।",
      },
      {
        type: "para",
        text: "वेबसाइट पर प्रकाशित विचार संबंधित लेखक के व्यक्तिगत विचार हो सकते हैं और आवश्यक नहीं कि वे Denva Post की आधिकारिक संपादकीय राय का प्रतिनिधित्व करें।",
      },
      {
        type: "para",
        text: "बाहरी वेबसाइटों के लिंक केवल पाठकों की सुविधा के लिए उपलब्ध कराए जाते हैं। उन वेबसाइटों की सामग्री, सेवाओं अथवा गोपनीयता नीतियों के लिए Denva Post उत्तरदायी नहीं होगा।",
      },
    ],
  },
};

// Ordered list — matches Footer link order.
export const POLICY_ORDER = [
  "advertise",
  "editorial",
  "fact-check",
  "corrections",
  "privacy",
  "terms",
  "disclaimer",
];

export const POLICIES = D;

export function getPolicy(slug) {
  return D[slug] || null;
}
